// FILE: /src/Components/Sidebar.js (FULLY UPDATED)

import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; // <-- IMPORT useLocation
import { useSelector, useDispatch } from "react-redux";
import { Modal, Input, Tooltip } from "antd";

import { StoreSideBar } from "../store/Slices/SIdeSlice";
import { fetchGroups, setSelectedGroup } from "../store/Slices/GroupSlice";
import Logo from "../Assets/Icons/Group 619.svg";
import publishing from "../Assets/publishing.webp";
import Assets from "../Assets/Cloud.webp";

import Apps from "../Assets/apps.webp";

import Ai from "../Assets/ai.webp";


import Reports from "../Assets/reports.webp";
import Seo from "../Assets/SEO.webp";


import Profile from "../Assets/profile.webp";
import CreateBrandWorkflowModal from "./CreateGroup/CreateBrandWorkflowModal";
import ConnectProfileModal from "./ConnectProfileModal";
import UsageTracker from "./Dashboard/UsageTracker";
import UpgradeModal from "./BuySubscription/UpgradeModal";

const FEEDBACK_FORM_URL =
  process.env.REACT_APP_FEEDBACK_FORM_URL ||
  "https://forms.gle/LmVJ5jfs2hV7e6SX9";

export default function Sidebar() {
    const selector = useSelector((state) => state.SideBarName[0]);
    const { groups, selectedGroup } = useSelector((state) => state.groups);
    const { subscription } = useSelector((state) => state.subscription);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation(); // <-- ADD THIS HOOK

    const [openDropdown, setOpenDropdown] = useState(null);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
    const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
    const [isCreateBrandModalOpen, setIsCreateBrandModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [upgradeModal, setUpgradeModal] = useState({
    visible: false,
    message: "",
    featureName: "Reports",
    });

    const sidebarItems = useMemo(() => [
{
name: "Copilot",
icon: Ai,
path: "/",
exactPath: true,
},
{
name: "Publishing",
icon: publishing,
path: "/Publishing",
subItems: [
{ name: "Calender", path: "Publishing" },
{ name: "Queue", path: "QueuePage" },
// { name: "Links", path: "Links" }

]
},
{
name: "Reports",
icon: Reports,
path: "/ProfileReports",
subItems: [
{ name: "Profile Reports", path: "ProfileReports" },
{ name: "Post Reports", path: "PostReports" }
]
},
{
    name: "SEO",
    icon: Seo,
    path: "/SEO/Content",
    subItems: [
        {
            name: "Content",
            path: "SEO/Content",
        },
        {
            name: "Settings",
            path: "SEO/Settings",
        },
    ],
},
{
name: "Assets",
icon: Assets,
path: "/Library",
subItems: [
{ name: "Brand Kit", path: "BrandKit" },
{ name: "Media", path: "Assets" },
{ name: "Brands", path: "GroupsProfile" }
]
},
{
name: "Apps",
icon: Apps,
path: "/Apps"
},
{
name: "Profile",
icon: Profile,
onClick: () => setIsConnectModalOpen(true)
}
], []);
    
    useEffect(() => {
const currentPath = location.pathname;
let activeName = null;
let parentName = null;

for (const item of sidebarItems) {
if (item.subItems) {
const subItemMatch = item.subItems.find((subItem) => {
  const subItemPath = `/Dashboard/${subItem.path}`;

  return (
    currentPath === subItemPath ||
    currentPath.startsWith(`${subItemPath}/`)
  );
});

if (subItemMatch) {
activeName = subItemMatch.name;
parentName = item.name;
break;
}
} else if (
item.path &&
(
item.exactPath
? currentPath === "/Dashboard" || currentPath === "/Dashboard/"
: currentPath.startsWith(`/Dashboard${item.path}`)
)
) {
activeName = item.name;
break;
}
}

if (currentPath === "/Dashboard" || currentPath === "/Dashboard/") {
activeName = "Copilot";
}

if (activeName) {
dispatch(StoreSideBar(activeName));
}

setOpenDropdown(parentName);
}, [location.pathname, dispatch, sidebarItems]);

    useEffect(() => {
        dispatch(fetchGroups());
    }, [dispatch]);
    
    const toggleDropdown = (name) => {
setOpenDropdown((currentDropdown) =>
currentDropdown === name ? null : name
);
};
    
    const filteredGroups = useMemo(() => {
        const activeGroups = groups.filter(g => g.status !== 'pending');
        if (!searchTerm) {
            return activeGroups;
        }
        return activeGroups.filter(group =>
            group.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [groups, searchTerm]);
    
    const reportsEnabled = subscription?.plan?.reports_enabled === true;
    const seoEnabled = subscription?.plan?.seo_enabled === true;

const openReportsUpgradeModal = () => {
setUpgradeModal({
visible: true,
featureName: "Reports",
message: "Reports are not included in your current plan. Please upgrade to access Profile and Post Reports.",
});
};

const openSeoUpgradeModal = () => {
setUpgradeModal({
visible: true,
featureName: "SEO",
message: "The SEO panel is not included in your current plan. Please upgrade to access SEO Content and Settings.",
});
};

const handleSidebarItemClick = (item) => {
if (item.name === "Reports" && !reportsEnabled) {
openReportsUpgradeModal();
return;
}

if (item.name === "SEO" && !seoEnabled) {
openSeoUpgradeModal();
return;
}

if (item.path && !item.subItems) navigate(`/Dashboard${item.path}`);
if (item.subItems) toggleDropdown(item.name);
if (item.onClick) item.onClick();

dispatch(StoreSideBar(item.name));
};

const handleReportsSubItemClick = (event, subItem, parentName) => {
if (parentName === "Reports" && !reportsEnabled) {
event.preventDefault();
openReportsUpgradeModal();
return;
}

if (parentName === "SEO" && !seoEnabled) {
event.preventDefault();
openSeoUpgradeModal();
return;
}

dispatch(StoreSideBar(subItem.name));
};

const logOut = () => {
localStorage.clear();
sessionStorage.clear();
window.location.href = "/";
};

return (
        <>
            <div className="w-64 bg-sidebar-bg text-sidebar-text h-screen flex flex-col relative">
                <img style={{ cursor: "pointer" }} onClick={() => navigate("/Dashboard")} src={Logo} alt="Logo" className="object-contain h-16 w-66 p-L-2 border-b border-sidebar-border"/>
                <ul className="mt-4 px-2">
                  <li>
                    <div className="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-sidebar-active-bg border-2 border-dashed border-sidebar-border" onClick={() => setIsGroupModalOpen(true)}>
                      <span className="flex-grow truncate">
                        {selectedGroup && selectedGroup !== "undefined" ? (
                          <div className="flex items-center justify-start gap-2">
                            <i className="fa fa-chevron-down text-xs"></i>
                            <span>{selectedGroup}</span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 text-sidebar-text">
                            <i className="fa fa-chevron-down text-xs"></i>
                            <span>Select a group</span>
                          </div>
                        )}
                      </span>
                    </div>
                  </li>
                </ul>
                <ul className="flex-grow space-y-1 mt-6 px-2">
                  {sidebarItems.map((item, index) => (
                    <li key={index}>
                      <div>
                        <div
                          className={`flex items-center px-4 py-2 rounded-lg cursor-pointer transition-colors ${
                            selector === item.name ? "bg-sidebar-active-bg text-sidebar-active-text" : "hover:bg-sidebar-hover-bg"
                          }`}
                          onClick={() => handleSidebarItemClick(item)}
                        >
                          <img src={item.icon} alt={`${item.name} Icon`} className="h-4 w-4 mr-4"/>
                          <span>{item.name}</span>
                          {item.subItems && (
                          <i
                          className={`fa fa-chevron-down ml-auto text-xs transform transition-transform ${
                          openDropdown === item.name ? "rotate-180" : ""
                          }`}
                          />
                          )}
                        </div>
                        {item.subItems && openDropdown === item.name && (
                          <ul className="ml-8 mt-2 space-y-2">
                            {item.subItems.map((subItem, subIndex) => (
                              <li key={subIndex}>
                                <Link
to={subItem.path}
onClick={(event) => handleReportsSubItemClick(event, subItem, item.name)}
className={`block px-4 py-1.5 text-sm rounded-lg transition-colors ${
selector === subItem.name
? "bg-sidebar-active-bg text-sidebar-active-text font-semibold"
: "text-sidebar-text hover:bg-sidebar-hover-bg"
}`}
>
{subItem.name}
{(item.name === "Reports" && !reportsEnabled) ||
(item.name === "SEO" && !seoEnabled) ? (
<i className="fa-solid fa-lock ml-2 text-xs opacity-70"></i>
) : null}
</Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>

                <UsageTracker />

                <div className="p-2 border-t border-sidebar-border relative">
                  <button className="flex items-center w-full px-2 py-2 rounded-lg hover:bg-sidebar-hover-bg" onClick={() => setShowSubMenu((prev) => !prev)}>
                    <i className="fa fa-cog h-4 w-4 mr-4"></i>
                    <span>Settings</span>
                    <i className={`fa fa-chevron-${showSubMenu ? "up" : "down"} ml-auto text-xs`}></i>
                  </button>
                  {showSubMenu && (
<ul className="bg-sidebar-bg border border-sidebar-border rounded-lg shadow-lg absolute left-2 right-2 z-10 bottom-full mb-1">
<li className="border-b border-sidebar-border">
<Link to="https://oolook.in/privacy" className="block px-4 py-2 hover:bg-sidebar-hover-bg rounded-t-lg text-sm">Privacy Policy</Link>
</li>
<li className="border-b border-sidebar-border">
<Link to="AccountSetting" className="block px-4 py-2 hover:bg-sidebar-hover-bg text-sm">Account Billing</Link>
</li>
<li className="border-b border-sidebar-border">
<Link to="https://calendly.com/yogesh-oolook/30min" className="block px-4 py-2 hover:bg-sidebar-hover-bg text-sm">Support</Link>
</li>
<li>
<button onClick={logOut} className="w-full text-left px-4 py-2 hover:bg-sidebar-hover-bg rounded-b-lg text-sm">Log Out</button>
</li>
</ul>
)}
</div>

<Tooltip
  title="Report a bug, request a feature, or send feedback"
  placement="right"
>
  <button
    type="button"
    onClick={() =>
      window.open(FEEDBACK_FORM_URL, "_blank", "noopener,noreferrer")
    }
    className="absolute right-1 bottom-48 w-8 h-8 rounded-full bg-red-600 text-white shadow-xl border-2 border-red-300 hover:bg-red-700 hover:scale-105 transition-all flex items-center justify-center z-30"
    aria-label="Report feedback"
  >
    <i className="fa-solid fa-bug text-xl"></i>
  </button>
</Tooltip>
</div>

            <CreateBrandWorkflowModal isOpen={isCreateBrandModalOpen} onClose={() => setIsCreateBrandModalOpen(false)}/>
            
            <Modal
                title={
                    <div className="brand-modal-title">
                        <span className="brand-modal-title-icon" aria-hidden="true">
                            <i className="fa-solid fa-building"></i>
                        </span>
                        <div className="min-w-0">
                            <h2>Switch brand</h2>
                            <p>Select the workspace you want to use.</p>
                        </div>
                    </div>
                }
                open={isGroupModalOpen}
                onCancel={() => setIsGroupModalOpen(false)}
                footer={null}
                centered
                width={520}
                className="brand-selection-modal"
                rootClassName="brand-modal-root"
                destroyOnClose
            >
                <div className="brand-selection-content">
                    <Input
                        prefix={
                            <i
                                className="fa-solid fa-magnifying-glass"
                                aria-hidden="true"
                            ></i>
                        }
                        placeholder="Search brands"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        allowClear
                        className="brand-modal-input"
                        aria-label="Search brands"
                    />

                    <ul className="brand-selection-list">
                        {filteredGroups.length > 0 ? (
                            filteredGroups.map((group) => {
                                const isSelected = selectedGroup === group.name;

                                return (
                                    <li key={group.name}>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                dispatch(setSelectedGroup(group.name));
                                                setIsGroupModalOpen(false);
                                            }}
                                            className={`brand-selection-item ${
                                                isSelected
                                                    ? "brand-selection-item-selected"
                                                    : ""
                                            }`}
                                            aria-pressed={isSelected}
                                        >
                                            <span
                                                className="brand-selection-item-icon"
                                                aria-hidden="true"
                                            >
                                                <i className="fa-regular fa-building"></i>
                                            </span>
                                            <span className="brand-selection-item-copy">
                                                <span className="brand-selection-item-name">
                                                    {group.name}
                                                </span>
                                                <span className="brand-selection-item-status">
                                                    {isSelected
                                                        ? "Current brand"
                                                        : "Switch to this brand"}
                                                </span>
                                            </span>
                                            {isSelected && (
                                                <span
                                                    className="brand-selection-check"
                                                    aria-label="Selected"
                                                >
                                                    <i className="fa-solid fa-check"></i>
                                                </span>
                                            )}
                                        </button>
                                    </li>
                                );
                            })
                        ) : (
                            <li className="brand-selection-empty">
                                <span
                                    className="brand-selection-empty-icon"
                                    aria-hidden="true"
                                >
                                    <i className="fa-regular fa-building"></i>
                                </span>
                                <p>
                                    {searchTerm
                                        ? `No brands found for "${searchTerm}"`
                                        : "You haven't created any brands yet."}
                                </p>
                            </li>
                        )}
                    </ul>

                    <div className="brand-selection-footer">
                        <button
                            type="button"
                            onClick={() => {
                                setIsGroupModalOpen(false);
                                setIsCreateBrandModalOpen(true);
                            }}
                            className="brand-create-action"
                        >
                            <span
                                className="brand-create-action-icon"
                                aria-hidden="true"
                            >
                                <i className="fa-solid fa-plus"></i>
                            </span>
                            <span className="min-w-0 flex-1">
                                <span className="brand-create-action-title">
                                    Create a new brand
                                </span>
                                <span className="brand-create-action-description">
                                    Add another brand workspace to Oolook.
                                </span>
                            </span>
                            <i
                                className="fa-solid fa-chevron-right brand-create-action-arrow"
                                aria-hidden="true"
                            ></i>
                        </button>
                    </div>
                </div>
            </Modal>
            
            <ConnectProfileModal
isOpen={isConnectModalOpen}
onClose={() => setIsConnectModalOpen(false)}
/>
<UpgradeModal
isOpen={upgradeModal.visible}
onClose={() =>
setUpgradeModal({
visible: false,
message: "",
featureName: "",
})
}
message={upgradeModal.message}
featureName={upgradeModal.featureName}
/>
</>
);
}